import { Controller } from "stimulus"

export default class extends Controller {
    toggleEnabled(event) {
        const row = event.target.closest("[data-permitted-charge-types-row]");
        const defaultField = row.querySelector("[data-target='permitted-charge-types.default']");

        if (!event.target.checked) {
            defaultField.checked = false;
        }
    }

    selectDefault(event) {
        const row = event.target.closest("[data-permitted-charge-types-row]");
        const enabledField = row.querySelector("[data-target='permitted-charge-types.enabled']");

        enabledField.checked = true;
    }
}
